<template>
  <div v-click-out="() => $emit('close')"
       class="statistics-table-partner-drop-window">
    <button type="button"
            class="statistics-table-partner-drop-window__close"
            @click.prevent.stop="$emit('close')">
      <BaseSvg name="ico-close"
               width=".8rem"
               height=".8rem"/>
    </button>

    <div v-if="canShowField('invited_date')"
         class="statistics-table-partner-drop-window__date">
      {{ $tStatistic(resume.user_type === AGENT ? 'Agent from' : 'partner_drop_window_partner_from') }}
      {{ resume.invited_date | formatDate }}
    </div>
    <div class="statistics-table-partner-drop-window__name">
      {{ resume.fullname }}
    </div>
    <div class="statistics-table-partner-drop-window__info">
      <div v-if="canShowField('partners') && resume.user_type !== AGENT"
           class="statistics-table-partner-drop-window__info-item">
        {{ $tStatistic('partner_drop_window_in_network') }}
        <span class="statistics-table-partner-drop-window__info-item-value">
          {{ resume.partners }}
        </span>
      </div>
      <div v-if="canShowField('jobseekers')"
           class="statistics-table-partner-drop-window__info-item">
        {{ $tStatistic('partner_drop_window_invited_candidates') }}
        <span class="statistics-table-partner-drop-window__info-item-value">
          {{ resume.jobseekers }}
        </span>
      </div>
      <div v-if="canShowField('total_income')"
           class="statistics-table-partner-drop-window__info-item">
        {{ $tStatistic('partner_drop_window_total_income') }}
        <span class="statistics-table-partner-drop-window__info-item-value">
          {{ resume.total_income }}
        </span>
      </div>
      <router-link-modified :to="{name: routeName, query: {'f-referral': resume.id}}"
                            class="statistics-table-partner-drop-window__btn  base-btn  base-btn--green  base-btn--small">
        {{ $tStatistic('partner_drop_window_btn') }}
      </router-link-modified>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import { AGENT } from '../../constants/usersTypes';

  export default {
    name: 'StatisticsPageTablePartnerDropWindow',
    props: {
      resume: Object
    },
    data() {
      return {
        AGENT,
      };
    },
    computed: {
      ...mapGetters('user', [
        'isAgent',
        'isPartner',
      ]),
      routeName() {
        if (this.isAgent) {
          return 'account-agent-resumes-base-resumes'
        }

        if (this.isPartner) {
          return 'account-partner-resumes-base-resumes'
        }

        return 'account-moderator-candidates-resumes-base'
      }
    },
    methods: {
      canShowField(key) {
        const value = this.resume[key]
        return this.resume.hasOwnProperty(key) && value !== null && value !== undefined
      }
    }
  }
</script>

<style lang="less">

</style>
